import Api from "../../utils/axios";

export const LanguageApi = {
  // Create a new language
  createLanguage: (payload) => Api.post(`master/create-language`, payload),

  updateLanguage: (id, payload) =>
    Api.put(`master/update-language/${id}`, payload),
  getAllLanguages: () => Api.get(`master/get-all-language`),
  getLanguageById: (id) => Api.get(`master/get-language/${id}`),
  deleteLanguage: (id) => Api.delete(`master/delete-language/${id}`),

  createTranslation: {
    createLagnuageTranslation: (payload) =>
      Api.post("master/create-translation", payload),
    getAllTranslation: () => Api.get("master/get-all-translation"),
    updateTranslation: (payload) =>
      Api.put("master/update-translation", payload),
  },
};

export const MasterApi = {
  master: {
    createTaxMaster: (payload) => Api.post("master/create-tax-master", payload),
    getAllTaxMaster: (payload, search = "") =>
      Api.post(`master/get-all-tax-master?search=${search}`, payload),
    updateTaxMaster: (id, payload) =>
      Api.put(`master/update-tax-master/${id}`, payload),
    delteTaxMaster: (id) => Api.delete(`master/delete-tax-master/${id}`),

    //vehical apis
    createVehicle: (payload) => Api.post("master/create-vehical-type", payload),
    getAllVehicle: (payload, search = "") =>
      Api.post(`master/get-all-vehical-types?search=${search}`, payload),
    updateVehicle: (id, payload) =>
      Api.put(`master/update-vehical-type/${id}`, payload),
    deleteVehicle: (id) => Api.delete(`master/delete-vehical-type/${id}`),

    //Delivery type
    createDeliveryType: (payload) =>
      Api.post("master/create-delivery-type", payload),
    getAllDeliveryType: (payload, search = "") =>
      Api.post(
        `master/get-all-delivery-types-with-pagination?search=${search}`,
        payload
      ),
    getAllDeliveryTypeData: (payload, search = "") =>Api.get(`master/get-all-delivery-types`),
    updateDeliveryType: (id, payload) =>
      Api.put(`master/update-delivery-type/${id}`, payload),
    deleteDeliveryType: (id) => Api.delete(`master/delete-delivery-type/${id}`),
  },
};

export const TemplateApi = {
  master: {
    createCancellationReason: (payload) =>
      Api.post("master/create-cancellation-reason", payload),
    getAllCancellationReasons: (payload, search = "") =>
      Api.post(`master/get-all-cancellation-reason?search=${search}`, payload),
    getCancellationReasonById: (id) =>
      Api.get(`master/get-cancellation-reason/${id}`),
    updateCancellationReason: (id, payload) =>
      Api.put(`master/update-cancellation-reason/${id}`, payload),
    deleteCancellationReason: (id) =>
      Api.delete(`master/delete-cancellation-reason/${id}`),
  },
  privacyAndTerms: {
    customerPolicy: (payload) =>
      Api.post("admin/create-privacy-terms", payload),
    getCustomerPolicy: () => Api.get("admin/get-all-privacy-terms"),
    updateCustomerPolicy: (payload, id) =>
      Api.put(`admin/update-privacy-terms/${id}`, payload),
  },
  aboutUs: {
  createAboutUs: (payload) =>
    Api.post("admin/create-aboutus", payload),

  updateAboutUs: (payload, id) =>
    Api.put(`admin/update-aboutus/${id}`, payload),

  getAboutUsById: (id) =>
    Api.get(`admin/get-aboutus-by-id/${id}`),

  getAllAboutUs: () =>
    Api.get("admin/get-all-aboutus"),

  deleteAboutUs: (id) =>
    Api.delete(`admin/delete-aboutus/${id}`),
},

};

export const DiscountApi = {
  promocode: {
    getAllPromocode: (payload, search) =>
      Api.post(`admin/get-all-promocodes?search=${search}`, payload),
    getAllPromosale: (payload, search) =>
      Api.post(`vendor/get-all-sales?search=${search}`, payload),
  },
};

export const UnitApi = {
  master:{ createUnitMaster: (payload) => Api.post("master/create-unit", payload),
    getAllUnitMaster: () =>Api.get(`master/get-all-units`),
    updateUnitMaster: (id, payload) =>Api.put(`master/update-unit/${id}`, payload),
    getSingleUnitMaster: (id, payload) =>Api.put(`get-unit/${id}`, payload),
    delteUnitMaster: (id) => Api.delete(`master/delete-unit/${id}`),}
};
export const PackageApi = {
  master:{ createPackageMaster: (payload) => Api.post("master/create-packaging-master", payload),
    getAllPackageMaster: () =>Api.post(`/master/get-all-packaging-master`),
    updatePackageMaster: (id, payload) =>Api.put(`master/update-packaging-master/${id}`, payload),
    getSinglePackageMaster: (id, payload) =>Api.put(`/${id}`, payload),
    deltePackageMaster: (id) => Api.delete(`/${id}`),}
};


export const BasicSettings = {
  createSiteSettings: (payload) =>
    Api.post(`/admin/create-admin-logo-settings`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),
  updateSiteSettings: (payload, id) =>
    Api.put(`/admin/update-admin-logo-settings/${id}`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),
  getSiteSettings: () => Api.get(`admin/get-admin-logo-settings`),
};

export const PaymentGatewayAPI = {
  createPaymentGateway: (payload) =>
    Api.post(`/admin/create-payment-gateway`, payload),
  updatePaymentGateway: (payload, id) =>
    Api.put(`/admin/update-payment-gateway/${id}`, payload),
  getPaymentGateway: (id) => Api.get(`/admin/payment-gateway/${id}`),
  getAllPaymentGateways: () => Api.get(`/admin/get-all-payment-gateways`),
  deletePaymentGateway: (id) =>
    Api.delete(`/admin/delete-payment-gateway/${id}`),
};
